import * as React from 'react'
import { Link } from 'react-router-dom';

interface ISystemLink {
    className?: string,
    to: any,
    children?: any,
    title?: string,
    handleClick?(): void,
    downloadLink?: boolean,
}

export const SystemLink = (props: ISystemLink) => {
    return (
        props.to == null || props.to == undefined || props.to == '' || props.downloadLink ?
            <a onClick={props.handleClick} href={props.to} className={props.className} title={props.title} target="_blank">{props.children}</a> :
            <Link onClick={props.handleClick} to={props.to} className={props.className} title={props.title} target="_blank" >{props.children}</Link>
    )
}
